// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:4dcec0ac-b7e8-49f2-88a3-e54bced21d4c",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_a3xABqKBP",
    "aws_user_pools_web_client_id": "1hhov7grj0kkbbf9d9derov8dl",
    "oauth": {},
    "aws_user_files_s3_bucket": "mulligan-web-poc3a7c4278c48f44203ba47b2ad366d4fpoc3-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;